import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/integrations',
)({
  component: () => <Outlet />,
});
